"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsPrerenderUserAgent = void 0;

var getIsPrerenderUserAgent = function getIsPrerenderUserAgent() {
  return navigator != null && /prerender/i.test(navigator.userAgent);
};

exports.getIsPrerenderUserAgent = getIsPrerenderUserAgent;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/utils/userAgent.js
// module id = 194
// module chunks = 209 210 211 212